import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import axios from "axios";

export default function Add_data_modal({
  select_data,
  open_update_data_modal,
  onUpdateExpense,
}) {
  const [ren, setRen] = useState(false);
  const [update_modal_data, setUpdate_modal_data] = useState(select_data);
  const [add_data_modal_Show, set_update_data_modal_Show] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [errors, setErrors] = useState({});
  const [category, setCategory] = useState([]);
  const [hubs, setHubs] = useState([]);
  const [users, setUsers] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [newAttachments, setNewAttachments] = useState([]);

  useEffect(() => {
    if (select_data) {
      setUpdate_modal_data({
        ...select_data,
        id_hub: select_data.id_hub ? select_data.id_hub._id : "",
        id_vehicle: select_data.id_vehicle ? select_data.id_vehicle._id : "",

        id_expenseCategory: select_data.id_expenseCategory
          ? select_data.id_expenseCategory._id
          : "",
        id_user: select_data.id_user ? select_data.id_user._id : "",
      });
    }
  }, [select_data]);

  useEffect(() => {
    set_update_data_modal_Show(open_update_data_modal.modal_open);
  }, [open_update_data_modal]);

  const handleClose = () => {
    set_update_data_modal_Show(false);
  };

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/admin/users`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setUsers(response.data.users || []);
      } catch (error) {
        console.error("Error fetching users:", error);
        setUsers([]);
      }
    };

    const fetchVehicles = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/vehicles`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setVehicles(response.data.vehicles);
      } catch (error) {
        console.error("Error fetching vehicles:", error);
        setVehicles([]);
      }
    };

    const fetchHubs = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/hubs`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setHubs(response.data.hubs);
      } catch (error) {
        console.error("Error fetching hubs:", error);
        setHubs([]);
      }
    };

    const fetchCategories = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/expense-categories`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setCategory(response.data.expenseCategories);
      } catch (error) {
        setCategory([]);
      }
    };

    fetchUsers();
    fetchHubs();
    fetchCategories();
    fetchVehicles();
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "attachment") {
      const file = files?.[0];

      if (!file) return;

      const maxFileSize = 10 * 1024 * 1024; // 10 MB

      if (file.size > maxFileSize) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          attachment: "Each attachment must not exceed 10MB.",
        }));

        e.target.value = "";
        return;
      }

      setErrors((prevErrors) => ({
        ...prevErrors,
        attachment: "",
      }));

      setNewAttachments((prev) => [...prev, file]);

      // Allow selecting the same file again
      e.target.value = "";

      return;
    }

    setUpdate_modal_data((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUserChange = (e) => {
    const { value } = e.target;
    setUpdate_modal_data((prevData) => ({
      ...prevData,
      id_user: value,
    }));
  };

  const handleHubChange = (e) => {
    const { value } = e.target;
    setUpdate_modal_data((prevData) => ({
      ...prevData,
      id_hub: value,
    }));
  };

  const handleCategoryChange = (e) => {
    const { value } = e.target;
    setUpdate_modal_data((prevData) => ({
      ...prevData,
      id_expenseCategory: value,
    }));
  };
  const handleVehicleChange = (e) => {
    const { value } = e.target;
    setUpdate_modal_data((prevData) => ({
      ...prevData,
      id_vehicle: value,
    }));
  };
  const validateFields = () => {
    const newErrors = {};
    if (!update_modal_data.id_user) newErrors.id_user = "User ID is required";
    if (!update_modal_data.id_hub) newErrors.id_hub = "Hub is required";
    if (!update_modal_data.amount) newErrors.amount = "Amount is required";
    if (!update_modal_data.id_expenseCategory)
      newErrors.id_expenseCategory = "Category is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpdate = async () => {
    const token = localStorage.getItem("token");

    if (!validateFields()) {
      Swal.fire("Please fill in all required fields", "", "error");
      return;
    }

    Swal.fire({
      icon: "warning",
      title: "Are you sure you want to take this action?",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const { _id } = update_modal_data;
          if (!_id) {
            throw new Error("ID is not defined");
          }

          // Create a new FormData object
          const formData = new FormData();
          formData.append("id_user", update_modal_data.id_user);
          formData.append("id_hub", update_modal_data.id_hub);
          formData.append(
            "id_expenseCategory",
            update_modal_data.id_expenseCategory,
          );
          formData.append("comments", update_modal_data.comments);
          formData.append("amount", update_modal_data.amount);
          formData.append("date", update_modal_data.date);
          formData.append("transactionType", update_modal_data.transactionType);
          if (update_modal_data.id_vehicle) {
            formData.append("id_vehicle", update_modal_data.id_vehicle);
          }

          // if (update_modal_data.attachment instanceof FileList) {
          //   formData.append("attachment", update_modal_data.attachment[0]);
          // }
          if (newAttachments.length > 0) {
            newAttachments.forEach((file) => {
              formData.append("attachment", file);
            });
          }

          const res = await axios.put(
            `${process.env.REACT_APP_BASE_URL}/api/v1/expense/${_id}`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );

          if (res.data.success) {
            Swal.fire("Update success", "", "success");
            onUpdateExpense(update_modal_data);
            setRen(!ren);
          }
        } catch (error) {
          Swal.fire("Update failed", "", "error");
        }
        set_update_data_modal_Show(false);
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };

  return (
    <>
      <Modal show={add_data_modal_Show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Update Expense Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="id_user">
              <Form.Label>User *</Form.Label>
              <Form.Control
                as="select"
                name="id_user"
                value={update_modal_data.id_user || ""}
                onChange={handleUserChange}
                isInvalid={!!errors.id_user}
              >
                <option value="">Select User</option>
                {users.map((user) => (
                  <option key={user._id} value={user._id}>
                    {user.name || "Unknown Name"} (
                    {user.phonenumber || "Unknown Phone"} )
                  </option>
                ))}
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.id_user}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="id_user">
              <Form.Label>Vehicle *</Form.Label>
              <Form.Control
                as="select"
                name="id_vehicle"
                value={update_modal_data.id_vehicle || ""}
                onChange={handleVehicleChange}
              >
                <option value="">Select Vehicle</option>
                {vehicles.map((vehicle) => (
                  <option key={vehicle._id} value={vehicle._id}>
                    {vehicle.numberplate}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
            <Form.Group className="mb-3" controlId="id_hub">
              <Form.Label>Hub *</Form.Label>
              <Form.Control
                as="select"
                name="id_hub"
                value={update_modal_data.id_hub || ""}
                onChange={handleHubChange}
                isInvalid={!!errors.id_hub}
              >
                <option value="">Select Hub</option>
                {hubs.map((hub) => (
                  <option key={hub._id} value={hub._id}>
                    {hub.name}
                  </option>
                ))}
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.id_hub}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="id_expenseCategory">
              <Form.Label>Category *</Form.Label>
              <Form.Control
                as="select"
                name="id_expenseCategory"
                value={update_modal_data.id_expenseCategory || ""}
                onChange={handleCategoryChange}
                isInvalid={!!errors.id_expenseCategory}
              >
                <option value="">Select Category</option>
                {category.map((cat) => (
                  <option key={cat._id} value={cat._id}>
                    {cat.name}
                  </option>
                ))}
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.id_expenseCategory}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="transactionType">
              <Form.Label>Transaction Type *</Form.Label>
              <Form.Control
                as="select"
                name="transactionType"
                value={update_modal_data.transactionType || ""}
                onChange={handleChange}
                isInvalid={!!errors.transactionType}
              >
                <option value="">Select Transaction Type</option>
                <option value="credit">Credit</option>
                <option value="debit">Debit</option>
              </Form.Control>
            </Form.Group>
            <Form.Group className="mb-3" controlId="comments">
              <Form.Label>Comments</Form.Label>
              <Form.Control
                type="text"
                name="comments"
                value={update_modal_data.comments || ""}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="amount">
              <Form.Label>Amount *</Form.Label>
              <Form.Control
                type="number"
                name="amount"
                value={update_modal_data.amount || ""}
                onChange={handleChange}
                isInvalid={!!errors.amount}
              />
              <Form.Control.Feedback type="invalid">
                {errors.amount}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="date">
              <Form.Label>Date *</Form.Label>
              <Form.Control
                type="date"
                name="date"
                value={update_modal_data.date || ""}
                onChange={handleChange}
                isInvalid={!!errors.date}
              />
              <Form.Control.Feedback type="invalid">
                {errors.date}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>
                <b>Attachments</b>
              </Form.Label>

              <div>
                <input
                  id="updateAttachmentInput"
                  type="file"
                  name="attachment"
                  className="d-none"
                  onChange={handleChange}
                />

                <label
                  htmlFor="updateAttachmentInput"
                  className="btn btn-outline-primary btn-sm"
                  style={{ cursor: "pointer" }}
                >
                  + Add Attachment
                </label>
              </div>

              {errors.attachment && (
                <div className="text-danger mt-1">{errors.attachment}</div>
              )}
            </Form.Group>
            {newAttachments.length > 0 && (
              <Form.Group className="mb-3">
                <Form.Label>
                  <b>New Attachments</b>
                </Form.Label>

                {newAttachments.map((file, index) => (
                  <div
                    key={`${file.name}-${index}`}
                    className="d-flex justify-content-between align-items-center border rounded p-2 mb-2"
                  >
                    <div>
                      <div>{file.name}</div>

                      <small className="text-muted">
                        {(file.size / 1024 / 1024).toFixed(2)} MB
                      </small>
                    </div>

                    <Button
                      type="button"
                      variant="outline-danger"
                      size="sm"
                      onClick={() => {
                        setNewAttachments((prev) =>
                          prev.filter((_, i) => i !== index),
                        );
                      }}
                    >
                      Remove
                    </Button>
                  </div>
                ))}
              </Form.Group>
            )}
            {select_data?.attachment?.length > 0 && (
              <Form.Group className="mb-3">
                <Form.Label>
                  <b>Previous Attachments</b>
                </Form.Label>

                {select_data.attachment.map((file, index) => (
                  <div
                    key={`${file.public_id || file.url}-${index}`}
                    className="d-flex justify-content-between align-items-center border rounded p-2 mb-2"
                  >
                    <div className="text-truncate">
                      <div className="fw-semibold">
                        {file.fileName ||
                          file.public_id ||
                          `Attachment ${index + 1}`}
                      </div>

                      {file.mimeType && (
                        <small className="text-muted">{file.mimeType}</small>
                      )}
                    </div>

                    <a
                      href={file.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-outline-primary btn-sm ms-2"
                    >
                      View
                    </a>
                  </div>
                ))}
              </Form.Group>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleUpdate}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
